import configDevelopment from './development.json';
import configStaging from './staging.json';
import configProduction from './production.json';

interface IConfig {
    apiUrl: string;
    zasilkovnaApiKey: string;
    printerGroups: Array<{
        text: string;
        value: string;
        ipAddress: string;
    }>;
    websocetURL: string;
    returnWidgetURL: string;
    templateFilesUrl: string;
    favicon: string;
}

const enviroment = (process.env.REACT_APP_ENV || process.env.NODE_ENV).replace(/\s/g, '');
let config: IConfig = configDevelopment;

console.log({ enviroment });

switch (enviroment) {
    case 'staging':
        config = configStaging;
        break;
    case 'production':
        config = configProduction;
        break;
    default:
        config = configDevelopment;
        break;
}

if (process.env.REACT_APP_API_URL) {
    config = {
        ...config,
        apiUrl: process.env.REACT_APP_API_URL,
    };
}

const favicon = document.querySelectorAll('link[rel="icon"]')[0];
favicon?.setAttribute('href', `/${config.favicon}`);

export default config;
